// CountryListModel
class CountryListModel {
    constructor({status = null, country = []} = {}) {
        this.status = status;
        this.country = country.map((item) => CustomerCountry.fromJson(item));
    }

    // Method to convert JSON to CountryListModel instance
    static fromJson(json) {
        return new CountryListModel({
            status: json.status,
            country: json.country,
        });
    }

    // Method to convert CountryListModel instance to JSON
    toJson() {
        return {
            status: this.status,
            country: this.country.map((item) => item.toJson()),
        };
    }
}


// CustomerCountry Model
class CustomerCountry {
    constructor({
                    id = null,
                    country_code = null,
                    country_name = null,
                    phone_code = null,
                    currency_code = null,
                    currency_name = null,
                } = {}) {
        this.id = id;
        this.countryCode = country_code;
        this.countryName = country_name;
        this.phoneCode = phone_code;
        this.currencyCode = currency_code;
        this.currencyName = currency_name;
    }

    // Method to convert JSON to CustomerCountry instance
    static fromJson(json) {
        return new CustomerCountry({
            id: json.id,
            country_code: json.country_code,
            country_name: json.country_name,
            phone_code: json.phone_code,
            currency_code: json.currency_code,
            currency_name: json.currency_name,
        });
    }

    // Method to convert CustomerCountry instance to JSON
    toJson() {
        return {
            id: this.id,
            country_code: this.countryCode,
            country_name: this.countryName,
            phone_code: this.phoneCode,
            currency_code: this.currencyCode,
            currency_name: this.currencyName,
        };
    }
}

export default CountryListModel;